import React, { FC } from "react";
import { SymbolLibrary as SymbolLibraryUI } from "@evergis/ui";
import { SGisSymbolType, Symbol } from "@evergis/react";
import { useTranslation } from "react-i18next";

import { SymbolLibraryButtonProps } from "./types";

export const SymbolLibraryButton: FC<SymbolLibraryButtonProps> = ({ children, ...symbolLibraryProps }) => {
  const { t } = useTranslation("dialogs");

  return (
    <SymbolLibraryUI
      {...symbolLibraryProps}
      anchor={"open"}
      zIndex={10}
      getSymbol={({ symbol, id }) => <Symbol symbol={symbol as SGisSymbolType} size={40} key={id} />}
      selectSymbolText={t("classification.chooseSymbol")}
    >
      {children}
    </SymbolLibraryUI>
  );
};
